import useQueryParameters from 'utils/hooks/useQueryParameters';
import { useMemo } from 'react';
import { useModalHistory } from 'context/ModalRouter';
import { usePostsContainer } from 'components/posts/context';

const usePostDetailPagination = () => {
  const { posts } = usePostsContainer();
  const queryParams = useQueryParameters(['id']);
  const history = useModalHistory();

  const postIndex = useMemo(() => {
    if (queryParams.id) {
      const postId = parseInt(queryParams.id);

      return posts.allPosts.findIndex((post) => post.id === postId);
    }

    return -1;
  }, [posts, queryParams.id]);

  const canGoNext = () => {
    return postIndex !== -1 && postIndex < posts.allPosts.length - 1;
  };

  const canGoPrev = () => {
    return !!postIndex && postIndex !== -1;
  };

  const goPrev = () => {
    if (canGoPrev()) {
      const prevPostId = posts.allPosts[postIndex - 1]?.id;

      if (prevPostId) {
        history.replace({
          search: `?id=${prevPostId}`,
        });
      }
    }
  };

  const goNext = () => {
    if (canGoNext()) {
      const nextPostId = posts.allPosts[postIndex + 1]?.id;

      if (nextPostId) {
        history.replace({
          search: `?id=${nextPostId}`,
        });
      }
    }
  };

  return {
    goNext,
    goPrev,
    canGoNext: canGoNext(),
    canGoPrev: canGoPrev(),
  };
};

export default usePostDetailPagination;
